import Swal from "sweetalert2"

interface EmailResult {
  mail?: string | null
  to: string
  error?: string
}

interface EmailStatusData {
  status: string
  data: EmailResult[]
}


export function showEmailStatus(emailData: EmailStatusData) {
    // Separar correos exitosos y con errores
    const successfulEmails = emailData.data.filter((item) => !item.error)
    const failedEmails = emailData.data.filter((item) => item.error)

    // Crear el HTML con Bootstrap 4
    const htmlContent = `
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h4 class="text-center mb-4">
              <i class="fas fa-envelope"></i> Reporte de Envío de Correos
            </h4>
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-6">
            <div class="card border-success">
              <div class="card-header bg-success text-white">
                <h5 class="mb-0">
                  <i class="fas fa-check-circle"></i> 
                  Enviados Exitosamente (${successfulEmails.length})
                </h5>
              </div>
              <div class="card-body" style="max-height: 200px; overflow-y: auto;">
                ${
                  successfulEmails.length > 0
                    ? successfulEmails
                        .map(
                          (email) => `
                    <div class="alert alert-success py-2 mb-2">
                      <small><i class="fas fa-check text-success"></i> ${email.to}</small>
                    </div>
                  `,
                        )
                        .join("")
                    : '<p class="text-muted">No hay correos enviados exitosamente</p>'
                }
              </div>
            </div>
          </div>
          
          <div class="col-md-6">
            <div class="card border-danger">
              <div class="card-header bg-danger text-white">
                <h5 class="mb-0">
                  <i class="fas fa-exclamation-triangle"></i> 
                  Errores (${failedEmails.length})
                </h5>
              </div>
              <div class="card-body" style="max-height: 200px; overflow-y: auto;">
                ${
                  failedEmails.length > 0
                    ? failedEmails
                        .map(
                          (email) => `
                    <div class="alert alert-danger py-2 mb-2">
                      <small>
                        <i class="fas fa-times text-danger"></i> 
                        <strong>${email.to}</strong><br>
                        <span class="text-muted">${email.error}</span>
                      </small>
                    </div>
                  `,
                        )
                        .join("")
                    : '<p class="text-muted">No hay errores</p>'
                }
              </div>
            </div>
          </div>
        </div>
        
        <div class="row mt-3">
          <div class="col-12">
            <div class="alert alert-info">
              <strong>Resumen:</strong> 
              ${successfulEmails.length} correos enviados, 
              ${failedEmails.length} errores
            </div>
          </div>
        </div>
      </div>
    `

    // Determinar el tipo de alerta basado en los resultados
    let icon: "success" | "warning" | "error" = "success"
    let title = "Correos Enviados"

    if (failedEmails.length > 0 && successfulEmails.length > 0) {
      icon = "warning"
      title = "Envío Parcialmente Exitoso"
    } else if (failedEmails.length > 0 && successfulEmails.length === 0) {
      icon = "error"
      title = "Error en el Envío"
    }

    Swal.fire({
      title: title,
      html: htmlContent,
      icon: icon,
      width: "800px",
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: "Entendido",
      confirmButtonColor: "#007bff",
      customClass: {
        popup: "swal-wide",
        htmlContainer: "swal-html-container",
      },
    })
  }